module.exports = __webpack_public_path__ + "static/media/soporte.80b46d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contenido/soporte.png
// module id = 325
// module chunks = 0